/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1431
 */

var r = require(/* 1432 */"../../../../../253/2568/2569/2570/1432/index")
var i = require(/* 862 */"./862/index")
module.exports = function (e, t) {
  return e && r(e, t, i)
}
